import Button from '../../../button/button';
import './Address.css';

export const Address = () => (
  <div className='info--address-container'>
    <div className='info--address-address-container'>
      <span className='info--address-address-text'>
        {'Chateau\nMephis Kalaki'}
      </span>
      <img
        src='/images/info_heart.svg'
        className='info--address-address-img'
        alt='Love'
      />
    </div>

      <div className='info--address-button-cotainer'>
        <a
          href="https://maps.app.goo.gl/Ewtjadb1jQRLYqQq5"
          target="_blank"
          rel="noreferrer"
        >
          <Button
            className='info--address-button'
            text='Посмотреть на карте'
            onClick={async () => {}}
          />
        </a>

        <img
          src="/images/info_arrow_desktop.svg"
          className='info--address-arrow info--address-arrow-desktop'
          alt="->"
        />
        <img
          src="/images/info_arrow_mobile.svg"
          className='info--address-arrow info--address-arrow-mobile'
          alt="->"
        />
      </div>

  </div>
)
